export default "__VITE_ASSET__Cdzlu0mZ__"